<template>
<v-container fluid>
    <PressingItemComponent/>
    <PressingTableComponent />
</v-container>
   

</template>

<script>
// @ is an alias to /src
import PressingItemComponent from "@/components/PressingItemComponent.vue";
import PressingTableComponent from "@/components/PressingTableComponent.vue";

import {serverBus} from "../main";

export default {
  name: "pressing",
  components: {
    PressingItemComponent,
    PressingTableComponent
  },
  mounted() {
    //alert("pretakanje");
    serverBus.$off("pressing");
  }
};
</script>
           
<style scoped lang='scss'>
</style>
